import { createFileRoute } from "@tanstack/react-router"
import LeadDocketComingSoon from "@/components/coreLeadDocket/LeadDocketComingSoon"

const LeadAutomationsPage = () => <LeadDocketComingSoon title="Lead automations" />

export const Route = createFileRoute("/core/lead-docket/automations")({
  component: LeadAutomationsPage
})
